import React from 'react'

export type UseTriggerContextProps = {
  opened: boolean
  close: Function
}

const UseTriggerContext = React.createContext<UseTriggerContextProps>(null as any)

export default UseTriggerContext
